<h2 mat-dialog-title>{{ 'locations.dialogs.confirmAddress' | t }}</h2>
<form [formGroup]="form" (ngSubmit)="submitForm()">
  <sn-form [form]="form" [fields]="formDataStep.fields" [(model)]="formModel"></sn-form>
  <mat-dialog-actions align="end">
    <button mat-button type="button" mat-dialog-close color="danger">{{ 'common.close' | t }}</button>
    <button mat-button type="submit" color="success">{{ 'common.confirm' | t }}</button>
  </mat-dialog-actions>
</form>
